import {
  FilterState,
  UIDataDrivenFilterstate,
  SelectedPartitionType,
  PartitionType,
} from 'types';

const getState = (state: FilterState) => state?.dataDrivenFilters;
const getUI = (state: FilterState) =>
  getState(state).ui || ({} as UIDataDrivenFilterstate);
const getData = (state: FilterState) => getState(state)?.data;
const getPartitions = (state: FilterState): PartitionType[] =>
  getData(state)?.partitions;

const getOriginalPartitions = (state: FilterState): PartitionType[] =>
  getData(state)?.originalPartitions;

const getSelectedPartitions = (state: FilterState): SelectedPartitionType[] =>
  getData(state)?.selectedPartitions || [];

const getIsLoading = (state: FilterState): boolean => getUI(state)?.loading;
const getError = (state: FilterState): string => getUI(state)?.error;

const getSelectedPartitionByIndex = (index: number) => (state: FilterState) => {
  return getSelectedPartitions(state)?.[index];
};

const getSelectedFilterByIndex =
  ({
    selectedPartitionIndex,
    selectedFilterIndex,
  }: {
    selectedPartitionIndex: number;
    selectedFilterIndex: number;
  }) =>
  (state: FilterState) => {
    return getSelectedPartitionByIndex(selectedPartitionIndex)(state)?.data
      .selectedFilters[selectedFilterIndex];
  };

export default {
  getState,
  getUI,
  getData,
  getPartitions,
  getSelectedPartitions,
  getSelectedPartitionByIndex,
  getSelectedFilterByIndex,
  getIsLoading,
  getError,
  getOriginalPartitions,
};
